const PrepareIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected
    ? 'var(--forbrand-primary)'
    : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.91101 10.7287L2.59433 7.41199L1.6665 8.33328L5.91101 12.5778L14.5677 3.92129L13.6464 3L5.91101 10.7287Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}

export default PrepareIcon
